module.exports = __webpack_public_path__ + "img/H-B-2-unload-standup-shadow.da59f32b.png";